const textKeyIsSet = (textKey?: string) =>
	textKey !== undefined && !textKey.startsWith('??') && !textKey.endsWith('??') && textKey.length > 0;

export default textKeyIsSet;
